// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-heigth {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body {\r\n  padding-top: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;
